import React, {useState, useEffect, useRef} from 'react';
import './ListNavbar.css';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

export default function ShortListNavbar({app_user, show_display}) 
{
    const {setMainColumnDisplayType, num_display_columns} = useCTAL();

    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_actions] = useState('checklist'); 
    const [img_info]    = useState('info'); 
    
    const [img_actions_file, setImgActionsFile] = useState(img_loc + img_actions + img_sel + img_ext); 
    const [img_info_file,    setImgInfoFile]    = useState(img_loc + img_info    + img_ext); 

    const [current_display_type, setCurrentDisplayType] = useState("action-item-list"); 
     
    const tooltipRef_actions = useRef(null);
    const tooltipRef_info    = useRef(null);

    useEffect(() => {
        const tooltip_actions = new window.bootstrap.Tooltip(tooltipRef_actions.current, { container: 'body', trigger: 'hover' });
        const tooltip_info    = new window.bootstrap.Tooltip(tooltipRef_info.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_actions.dispose();
            tooltip_info.dispose();
        };
    }, []);

    const change_display = (display_type) => {
        if (display_type == current_display_type) return; //No Change

        setImgActionsFile(img_loc + img_actions + img_ext);
        setImgInfoFile(img_loc    + img_info    + img_ext);

        switch (display_type)
        {
            case "action-item-list":    setImgActionsFile(img_loc + img_actions + img_sel + img_ext); break;
            case "short-list-information": setImgInfoFile(img_loc + img_info    + img_sel + img_ext); break;
        }
        setCurrentDisplayType(display_type);
        show_display(display_type);
    } 

    var user_link_icon;
    if (num_display_columns < 3)
        user_link_icon = <a class="me-3" href="#"><img class="card-icon" src="./images/user.svg" alt="user-display" border="0" onClick={ () => setMainColumnDisplayType("User") }/></a>;
    else
        user_link_icon = <></>;

    return (
        <>
            <nav class="my-list-nav-bar navbar border-bottom border-body py-0 mt-2" sticky-top>
                <div class="container-fluid">
                    {user_link_icon}       
                    <a class="navbar-brand me-auto" href="#">My Short List</a>
                    
                    <div className="ms-auto">
                        <a href="#" ref={tooltipRef_actions} data-bs-toggle="tooltip" data-bs-title="Short List Actions"     data-bs-delay="750"><img class="card-icon"     src={img_actions_file} alt="actions" border="0" onClick={ () => change_display("action-item-list") }/></a>
                        <a href="#" ref={tooltipRef_info}    data-bs-toggle="tooltip" data-bs-title="Short List Information" data-bs-delay="750"><img class="card-icon-end" src={img_info_file}    alt="info"    border="0" onClick={ () => change_display("short-list-information") }/></a>
                    </div>
                </div>
            </nav>
        </>
    );
}